import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import { UiSlider } from "../../../components/common/UiSlider";
import Asos from "../../../../../styles/img/asos.png"
import LevisLogo from "../../../../../styles/img/levis-logo.jpg"
import SliderHeart from "../../../../../styles/img/slider-heart-icon.png";
import { UiNextArrow, UiPrevArrow } from "../../../components/common/UiSliderArrows.jsx";
import { UiTopBgSlider, UiTopBgSliderLeftContent, UiTopLoyaltyBgSlider } from "../../../components/common/UiTopBgSliderElements"
import UiShopCard from "../../../components/cards/UiShopCard"
import {UiButtonPrimary} from "../../../components/form/UiButton"

export default function LoyaltyHomeBanner(props) {

    return (
        <>
            <UiTopLoyaltyBgSlider>
                <UiCol lg="8" className="sb-loyalty-left-content">
                    <UiTopBgSliderLeftContent>
                        <UiSingleRow>
                            <UiCol lg="12" className="sb-loyalty-home-banner mt-4">
                                <h3>Asos Shop</h3>
                            </UiCol>
                            <UiCol lg="4">
                                <div className='sb-loyalty-top-img'>
                                    <img src={Asos} className="img-fluid" />
                                </div>
                            </UiCol>
                            <UiCol lg="4">
                                <div className='sb-loyalty-top-img'>
                                    <img src={Asos} className="img-fluid" />
                                </div>
                            </UiCol>
                            <UiCol lg="4">
                                <div className='sb-loyalty-top-img'>
                                    <img src={Asos} className="img-fluid" />
                                </div>
                            </UiCol>
                            <UiCol lg="12" className="sb-loyalty-home-banner-text mt-4">
                                <p>It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                            </UiCol>
                        </UiSingleRow>
                    </UiTopBgSliderLeftContent>
                </UiCol>
                <UiCol lg="4" className="sb-right-col d-flex justify-content-center">
                    <div className='sb-loyalty-card'>
                        <h4>Levis Store</h4>
                        <img src={LevisLogo}/>
                        <p>Aldus PageMaker including versions of Lorem Ipsum.</p>
                        <UiButtonPrimary btnName="Visit"/>
                    </div>
                </UiCol>

            </UiTopLoyaltyBgSlider>
        </>
    )
}
